var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKowa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1577.06 505.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2,.cls-4{fill:#ffc82f;}.cls-3{fill:#253fc8;}.cls-4{opacity:0.54;}.cls-5{fill:#ffc820;}.cls-6{fill:#fff;}.cls-7{fill:#232323;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "KOWA Logo Full") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 125.93,
    y: 220.69,
    width: 86.29,
    height: 4,
    transform: "translate(-91.44 121.16) rotate(-31.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 238.83,
    y: 182.26,
    width: 4,
    height: 86.29,
    transform: "translate(-82.91 288.61) rotate(-54.15)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 279.36,
    y: 227.65,
    width: 86.29,
    height: 4,
    transform: "translate(-73.15 244.07) rotate(-37.54)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 283.63,
    cy: 261.96,
    r: 16.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 205.86,
    cy: 200.14,
    r: 21.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 132.3,
    cy: 245.24,
    r: 13.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M385.12,219.08a35.83,35.83,0,0,1-39.25,13.28c16.38,30,24.68,54.67,24.68,73.32,0,88.22-73.88,160-164.69,160S41.17,393.9,41.17,305.68c0-19.28,8.88-45,26.38-76.4,14.8-26.57,35.57-56.72,61.72-89.61,24.62-30.95,49.44-58.54,67-77.29a13.28,13.28,0,0,1,19.24,0c17.54,18.75,42.36,46.34,67,77.29q21.8,27.39,38.49,52.11a35.79,35.79,0,0,1,29.57-29q-15.81-22.84-35.73-47.86A1324.47,1324.47,0,0,0,220.55,9.13l-5.42-5.35a13.26,13.26,0,0,0-18.54,0l-5.41,5.35A1323.45,1323.45,0,0,0,96.94,114.9C32.62,195.74,0,259.92,0,305.68,0,359.1,21.42,409.32,60.3,447.09s90.58,58.58,145.56,58.58,106.69-20.8,145.57-58.58,60.29-88,60.29-141.41C411.72,281.76,402.81,252.81,385.12,219.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M70.65,296a129,129,0,1,0,257.85,8.24c-8.53-1.22-17.35-1.55-28.12-1.93-25.06-.9-59.57,6-69.6,8.92-6.12,1.79-18.53,5.92-24.22,8.21-14.68,5.9-26,7-41.7,8.6a118.93,118.93,0,0,1-94.21-32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M328.84,304.1A129.4,129.4,0,1,1,70.3,295.47a119.16,119.16,0,0,1,99.89,3h0a118.83,118.83,0,0,1,19.52,12.27A97.15,97.15,0,0,0,232.48,330a119.31,119.31,0,0,0,96.36-25.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 115.26,
    cy: 332.58,
    r: 10.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 132.3,
    cy: 364.15,
    r: 13.95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 356.15,
    cy: 198.09,
    r: 26.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M604.46,240.38,701.35,363.1H631L549.39,255.34V363.1H491.26V122.76h58.13V228.48l82.27-105.72h69.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M901.75,134.83a115.06,115.06,0,0,1,43.68,43.85q16,28,16,63.4t-16.15,63.57a116,116,0,0,1-43.85,44q-27.72,15.81-61.36,15.8t-61.37-15.8a116,116,0,0,1-43.85-44q-16.16-28.22-16.15-63.57t16.15-63.4a116.26,116.26,0,0,1,43.85-43.85Q806.39,119,840.05,119,874,119,901.75,134.83ZM794.66,191.6q-16.83,18.53-16.83,50.48,0,31.62,16.83,50.31t45.39,18.7q28.2,0,45.21-18.7t17-50.31q0-31.62-16.83-50.31t-45.38-18.7Q811.49,173.07,794.66,191.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1320.74,122.76,1263.29,363.1h-72.08L1152.8,202.31,1114.05,363.1H1042L984.52,122.76h63.23l30.94,174.05,42.15-174h63.58l42.15,174.05,31.28-174Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1500.23,319.25h-90.08l-15,43.85H1334l88-238.64h67l88,238.64h-61.87Zm-15-44.19-29.92-88.39-30.26,88.39Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKowa);
export default __webpack_public_path__ + "static/media/kowa.6ee882f2b7cd42cb017f75fa0ac5d664.svg";
export { ForwardRef as ReactComponent };